import { trace } from 'rytm-helpers';


export const warNumberedLists = () => {
  const list = [...document.querySelectorAll('ol,ul')];
  list.forEach((el) => {
    trace("##", el.style.listStyleType);
    if (el.style) {
      if (el.style.listStyleType == 'lower-roman') {
        el.classList.add('list-roman-width-brackets');
      } else if (el.style.listStyleType == 'upper-alpha') {
        el.classList.add('list-alpha-width-brackets');
      } else if (el.style.listStyleType == 'lower-alpha') {
        el.classList.add('list-alpha-width-brackets');
      } else if (el.style.listStyleType == 'square') {
        el.classList.add('list-unsorted-dash');
      } else {
        
      }
    }
  });
}